import { createContext, useContext } from 'react';

// UI companion to the server-enforced impersonation write barrier.
export const ReadOnlyContext = createContext(false);
export const useReadOnly = () => useContext(ReadOnlyContext);
